module.exports = __webpack_public_path__ + "files/abfb6f2dc8030ce1767a8ecef01b2d09.png";